// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"4749ba5c","905":"1d5af690"}[chunkId] + ".chunk.js";
};